var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.658 3.0012C18.408 3.00118 18.148 3.10116 17.958 3.29114L16.1279 5.12099L19.8776 8.8713L21.7077 7.04145C22.0977 6.65148 22.0978 6.02148 21.7078 5.63145L19.368 3.29126C19.168 3.09124 18.918 3.00122 18.658 3.0012ZM15.0576 9.02091L15.9775 9.94098L6.91674 19.0002L5.99674 19.0002L5.99681 18.0802L15.0576 9.02091ZM3.99688 17.25L15.0578 6.19091L18.8075 9.94121L7.74657 21.0003L3.99657 21L3.99688 17.25Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit24Px);
export default __webpack_public_path__ + "static/media/edit_24px.81782bafefeea307434eeaaf73d03d7b.svg";
export { ForwardRef as ReactComponent };